import classNames from 'classnames';

import textClassSwitcher from '../../utils/textClassSwitcher';

import { authorBio } from '../Authors.css';
import type { TAuthorAttributes } from '../Authors.type';

interface Props {
  bio: string;
  className?: string;
  attributes: TAuthorAttributes;
}

const Bio = ({ bio, className = '', attributes }: Props) => {
  return (
    <span
      className={classNames(
        authorBio,
        textClassSwitcher(className, attributes?.bioFontSize || 'text-sm'),
        attributes?.bioTextTransform || 'normal-case',
      )}
    >
      {bio}
    </span>
  );
};

export default Bio;
